export const brandIndex = {
  "tab_name": "brand-index",
  "data": [
    {
      "name": "University of Brighton",
      "series": [
        {
          "name": "chatgpt",
          "value": 5.0
        }
      ]
    },
    {
      "name": "University of Central Lancashire",
      "series": [
        {
          "name": "chatgpt",
          "value": 9.0
        }
      ]
    },
    {
      "name": "University of Hull",
      "series": [
        {
          "name": "chatgpt",
          "value": 6.0
        }
      ]
    },
    {
      "name": "University of Salford",
      "series": [
        {
          "name": "chatgpt",
          "value": 6.0
        }
      ]
    },
    {
      "name": "University of West London",
      "series": [
        {
          "name": "chatgpt",
          "value": 5.0
        }
      ]
    }
  ],
  "evidence_sources": [
    {
      "category": "brand_analysis",
      "source": "Brand Index Analysis",
      "confidence": 0.88,
      "url": "https://www.brandindex.com",
      "snippet": "Comprehensive brand index analysis for educational institutions.",
      "type": "brand_analysis",
      "domain": "education"
    },
    {
      "category": "reputation_metrics",
      "source": "University Reputation Survey",
      "confidence": 0.85,
      "url": "https://www.timeshighereducation.com",
      "snippet": "University reputation and brand perception metrics.",
      "type": "survey",
      "domain": "education"
    }
  ],
  "recommendations": [
    {
      "category": "brand_enhancement",
      "issue": "Brand Index Improvement",
      "recommendation": "Focus on improving brand visibility and reputation through strategic marketing",
      "priority": "High",
      "expected_impact": "Increase brand index scores by 2-3 points"
    },
    {
      "category": "reputation_management",
      "issue": "Reputation Enhancement",
      "recommendation": "Develop comprehensive reputation management strategies",
      "priority": "Medium",
      "expected_impact": "Enhanced brand perception and recognition"
    }
  ],
  "cached": false,
  "timestamp": "2025-08-13T19:45:59.598223",
  "models_used": [
    "chatgpt"
  ],
  "plan_type": "university_paid"
};
